import "esbuild-css-modules-plugin-ns-css:src/js/components/tooltip/tooltip.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/tooltip/tooltip.module.css:injector.js";
export default new Proxy({
  "closeButton": "tooltip-module__closeButton_vvtmzq__1100",
  "contentBox": "tooltip-module__contentBox_vvtmzq__1100",
  "tooltip": "tooltip-module__tooltip_vvtmzq__1100",
  "tooltipArrow": "tooltip-module__tooltipArrow_vvtmzq__1100",
  "tooltipArrowBottom": "tooltip-module__tooltipArrowBottom_vvtmzq__1100",
  "tooltipArrowCentre": "tooltip-module__tooltipArrowCentre_vvtmzq__1100",
  "tooltipArrowLeft": "tooltip-module__tooltipArrowLeft_vvtmzq__1100",
  "tooltipArrowRight": "tooltip-module__tooltipArrowRight_vvtmzq__1100",
  "tooltipArrowTop": "tooltip-module__tooltipArrowTop_vvtmzq__1100",
  "tooltipContainer": "tooltip-module__tooltipContainer_vvtmzq__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      